import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'
import DatePicker from "react-datepicker"

import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import FilterSearch from 'pages/parts/FilterSearch'
import Pagination from 'pages/parts/Pagination'

import Rightbar from '../cheques/Rightbar'
import { PGET, GET } from 'helpers/api'
import { findFromArrayById, formatDateWithTime, formatMoney, formatDate, formatDateBackend, returnSign } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const reduxSettings = useSelector(state => state.settings)
	const reduxReport = useSelector(state => state.report)
	const reduxAccount = useSelector(state => state.account)

	const URL = `/services/web/api/cheque-by-clientId-pageList/`

	// POS ni tashqi ro'yxatdagi filtrdan olib kelamiz
	const inheritedPosId = reduxReport.reportClientFilter?.posId || reduxAccount.posId

	const [showRightBar, setShowRightBar] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)


	const [pageCount, setPageCount] = useState(0)
	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [filterData, setFilterData] = useState({
		posId: inheritedPosId,
		search: '',
		startDate: null,
		endDate: null,
	})

	const tableTotalAmount = useMemo(() => {
		if (!data?.length) return 0
		return data.reduce((sum, item) => sum + (Number(item?.totalPrice) || 0), 0)
	}, [data])

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = [...data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}

		if (item.chequeId !== 0) {
			if (boolean) {
				const response = await GET("/services/web/api/cheque-byId/" + item.id, {}, { loader: true })
				dataCopy[index]['itemsList'] = response
				dataCopy[index]['showSidebar'] = boolean
				setSelectedItem(response)
				setShowRightBar(boolean)
			} else {
				setShowRightBar(boolean)
				setSelectedItem({})
			}
		}
	}

	async function exportToExcel() {
		let excelUrl = `/services/web/api/cheque-by-clientId-excel/${reduxAccount?.posId}/` + reduxReport.reportSelectedClient.clientId
		if (filterData.startDate)
			excelUrl += returnSign(excelUrl) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			excelUrl += returnSign(excelUrl) + 'endDate=' + filterData.endDate
		const response = await GET(excelUrl)

		var excelHeaders = [[t('POS'), t('CASHBOX'), t('SHIFT_NUMBER'), t('CASHIER'), t('CHECK_NUMBER'), t('CHEQUE_DATE'),
		t('SYNC_DATE'), t('STATUS'), t('TOTAL')]]
		for (let i = 0; i < response.length; i++) {
			var excelItems = []
			excelItems.push(response[i].posName)
			excelItems.push(response[i].cashboxName)
			excelItems.push(response[i].shiftNumber)
			excelItems.push(response[i].cashierName)
			excelItems.push(response[i].chequeNumber)
			excelItems.push(formatDateWithTime(response[i].chequeDate))
			excelItems.push(formatDateWithTime(response[i].createdDate))
			if (response[i].returned === 0) excelItems.push(t('SUCCESS'))
			if (response[i].returned === 1) excelItems.push(t('PARTIAL_RETURN'))
			if (response[i].returned === 2) excelItems.push(t('RETURN'))
			excelItems.push(response[i].totalPrice)
			excelHeaders.push(excelItems)
		}
		const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
		styleExcelSheet(ws)
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, t('CHEQUES') + ".xlsx");
	}

	function checkFilter(fd = filterData) {
		if (
			fd.posId === null &&
			fd.search === '' &&
			!fd.startDate &&
			!fd.endDate
		) {
			setFilterDataExist(false)
		} else {
			setFilterDataExist(true)
		}
	}

	async function loadCheques(fd) {
		checkFilter(fd)
		const path = URL + fd.posId + `/${reduxReport.reportSelectedClient.clientId}`
		const response = await PGET(path, fd)
		if (response && response.data) {
			setPageCount(Math.ceil((response?.headers['x-total-count']) / reduxSettings.size))
			setData(response.data)
			setDropdownIsOpen(false)
		}
	}

	async function getData() {
		await loadCheques(filterData)
	}

	function resetFilter() {
		const next = {
			posId: reduxAccount.posId,
			search: '',
			startDate: null,
			endDate: null,
		}
		setFilterData(next)
		loadCheques(next)
	}

	async function paginate(pageData) {
		const fd = { ...filterData, page: pageData.selected, size: reduxSettings.size }
		const path = URL + fd.posId + `/${reduxReport.reportSelectedClient.clientId}`
		const response = await PGET(path, fd)
		if (response?.data) {
			setData(response.data)
			setFilterData({ ...fd })
		}
	}

	async function getPoses() {
		const response = await GET("/services/web/api/pos-helper", {}, { loader: true })
		if (response) {
			setPoses(response)
		}

	}

	useEffect(() => {
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getData()
	}, [filterData.search]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
						<div className="d-flex flex-wrap align-items-center">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, startDate: date ? formatDateBackend(date) : null })}
														placeholderText={t('FROM_DATE')}
													/>
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, endDate: date ? formatDateBackend(date) : null })}
														placeholderText={t('END_DATE')}
													/>
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button type="button" className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button type="button" className="btn btn-primary" onClick={() => getData()}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<button type="button" className="btn btn-outline-primary btn-wide" onClick={exportToExcel}>
								EXCEL
							</button>
						</div>
						<div className="text-nowrap fs-4">
							<b>{t('TOTAL')}:</b> {formatMoney(tableTotalAmount)}
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block my-3">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate && <span>{formatDate(filterData.startDate)}</span>}
										{(filterData.startDate && filterData.endDate) && <span>|</span>}
										{filterData.endDate && <span>{formatDate(filterData.endDate)}</span>}
									</span>
								}
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button type="button" className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-hover cursor mb-0">
							<thead>
								<tr>
									<th>{t('POS')}</th>
									<th className="text-center">{t('CASHBOX')}</th>
									<th className="text-center">{t('SHIFT_NUMBER')}</th>
									<th className="text-center">{t('CASHIER')}</th>
									<th className="text-center">{t('CHECK_NUMBER')}</th>
									<th className="text-center">{t('CHEQUE_DATE')}</th>
									<th className="text-center">{t('SYNC_DATE')}</th>
									<th className="text-center">{t('STATUS')}</th>
									<th className="text-center">{t('TOTAL')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index} onClick={() => toggleRightbar(true, item, index)}>
										<td>{(filterData.page || 0) * (reduxSettings.size || 20) + index + 1}. {item.posName}</td>
										<td className="text-center">{item.cashboxName}</td>
										<td className="text-center">{item.shiftNumber}</td>
										<td className="text-center">{item.cashierName}</td>
										<td className="text-center">{item.chequeNumber}</td>
										<td className="text-center">{formatDateWithTime(item.chequeDate)}</td>
										<td className="text-center">{formatDateWithTime(item.createdDate)}</td>
										<td className="d-flex justify-content-center">
											{item.returned === 0 &&
												<span className="bg-success bg-border text-white">{t('SUCCESS')}</span>
											}
											{item.returned === 1 &&
												<span className="bg-warning bg-border text-white text-nowrap">{t('PARTIAL_RETURN')}</span>
											}
											{item.returned === 2 &&
												<span className="bg-danger bg-border text-white">{t('RETURN')}</span>
											}
										</td>
										<td className="text-center text-nowrap">{formatMoney(item.totalPrice)} {item.currencyName}</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>
		</>
	)
}

export default Index
